/* global angular, moment */
/**
 * Created by lari on 03/05/2017.
 */
(function () {
  'use strict';
  angular.module('vcutils.sprhelp')
    .component('sprhelp', {
      restrict: 'E',
      bindings: {
        tip: '@',
        descref: '<?',
        file: '@?',
        video: '@?'
      },
      template: `
<!-- TODO: fix annozing mouse over behaviour, make extra links for video and pdf links -->
        <span class="sprhelp-component" data-hook="sprhelp-component">
      &nbsp;<span class="text-primary" ng-if="vm.complex === false"><i class="fa fa-info-circle" uib-popover="{{vm.tip}}" popover-trigger="'mouseenter'" popover-placement="auto top"></i></span>
      &nbsp;<span class="text-primary" ng-if="vm.complex === true"><i class="fa fa-info-circle" uib-popover-html="vm.getPopcontent()"
      popover-trigger="'mouseover outsideClick'" popover-title="{{vm.tip}}" popover-placement="auto top"></i></span>
        </span>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$sce',
        function ($log, $sce) {
          let vm = this;
          vm.getPopcontent = getPopcontent;

          vm.$onInit = function () {
            // noinspection JSUnresolvedVariable
            if (angular.isDefined(vm.descref) || angular.isDefined(vm.file)) {
              vm.complex = true;
              vm.template = '<div>';
              // noinspection JSUnresolvedVariable
              if (angular.isDefined(vm.descref)) {
                vm.template += '<p>';
                // noinspection JSUnresolvedVariable
                vm.template += vm.descref;
                vm.template += '</p>';
              }
              if (angular.isDefined(vm.file) || angular.isDefined(vm.video)) {
                vm.template += '<p>Mehr Informationen:</p><ul>';
              }

              if (angular.isDefined(vm.file)) {
                vm.template += '<li><a target="_blank" href="/help/';
                vm.template += vm.file;
                vm.template += '"><i class="fa fa-file-pdf-o"></i> Anleitung (PDF)</a></li>';
              }

              // TODO: add correct vimeo prefix, or maybe switch to embedded video
              if (angular.isDefined(vm.video)) {
                vm.template += '<li><a target="_blank" href="http://vimeo.com/sprechstunde/';
                vm.template += vm.video;
                vm.template += '"><i class="fa fa-video-camera"></i> Anleitung (Video)</a></li>';
              }

              if (angular.isDefined(vm.file) || angular.isDefined(vm.video)) {
                vm.template += '</ul>';
              }

              vm.template += '<div>';

              vm.popoverContent = $sce.trustAsHtml(vm.template);
            }
            else {
              vm.complex = false;
            }
          };

          function getPopcontent() {
            return vm.popoverContent;
          }

        }] // controller
    }); // component

// klammerfriedhof
}());
